import { Injectable } from '@angular/core';
import { ArboService } from 'src/app/services/arbo.service';
import { HttpService } from 'src/app/services/http.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ClientService {
  // Cache em memória
  private _membershipsCache: { data: any; timestamp: number } | null = null;
  private CACHE_TTL = 5 * 60 * 1000; // 5 minutos

  constructor(
    private arboService: ArboService,
    private httpService: HttpService
  ) { }

  create(data)  { return this.arboService.create('Client',data); }
  get(id)       { return this.arboService.get('Client',id); }
  update(data)  { return this.arboService.update('Client',data); }

  getMemberships() {
    if (this._membershipsCache && (Date.now() - this._membershipsCache.timestamp < this.CACHE_TTL)) {
      return Promise.resolve(this._membershipsCache.data);
    }
    return this.httpService.get(environment.arboUrl + `/Client/memberships`)
      .then(data => {
        this._membershipsCache = { data, timestamp: Date.now() };
        return data;
      });
  }

  invalidateCache() {
    this._membershipsCache = null;
  }
  // getByCPF(cpf) { return this.httpService.get(environment.arboUrl+`/Profile/cpf/${cpf}`); }
  // getByCelular(celular) { return this.httpService.get(environment.arboUrl+`/Profile/celular/${celular}`); }
}
